// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InternalDocument_wrapper__hHFYE","isViewDetail":"InternalDocument_isViewDetail__2Y3S-","fileList":"InternalDocument_fileList__zfvR9"};